/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React, { CSSProperties } from 'react';
import PropTypes from 'prop-types';


type ErrorBoundaryState = {
    hasError: boolean,
    error?: any,
    errorInfo?: any
}

type ErrorBoundaryProps = {
    children: JSX.Element | JSX.Element[] | null
}

const STYLE_RED: CSSProperties = { color: 'red' };
const STYLE_WRAP: CSSProperties = { whiteSpace: 'pre-wrap' };

//pokud selze vykreslovani obashu toho elementu, tak to neshodi cely render, ale jen tato cast.
export default class ErrorBoundary extends React.PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {

    public static propTypes = {
        children: PropTypes.any
    }

    public static getDerivedStateFromError() {
        return { hasError: true };
    }

    public constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    public componentDidCatch(error: any, info: any) {
        this.setState({
            error: error,
            errorInfo: info
        });
    }

    public render(): JSX.Element | JSX.Element[] | null {
        if (this.state.hasError) return this.renderError();

        if (this.props.children === undefined) return (null);

        return this.props.children;
    }

    private renderError(): JSX.Element {
        return (
            <div>
                <div style={STYLE_RED}>Vykreslení se nezdařilo</div>
                {this.renderDetail()}
            </div>
        );
    }

    private renderDetail(): JSX.Element | undefined {
        if (!this.state.error) return;

        return (
            <details style={STYLE_WRAP}>
                <div>{this.state.error.toString()}</div>
                <div>{this.state.errorInfo.componentStack}</div>
            </details>
        );
    }

}
